module.exports = __webpack_public_path__ + "static/media/horsecow.15456c53.glb";